import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { useGetDeliveryQuery, useDeliveriesUpdatedSubscription } from 'data/__generated__';
import { deliveryUpdatedHandler } from '../utils/deliverySubscriptionsHandlers';

import { Header, HeaderTitle } from 'components/Header';
import { Loader } from 'components/Loader';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

import { DeliveryDetailsForm } from './DeliveryDetailsForm';

type ParamTypes = {
    deliveryId: string;
};

export const DeliveryDetails = () => {
    const { deliveryId = '' } = useParams<ParamTypes>();

    const {
        loading: deliveryLoading,
        data: deliveryData,
        error: deliveryError,
    } = useGetDeliveryQuery({
        variables: { deliveryId },
    });

    useDeliveriesUpdatedSubscription({
        onData: ({ data: { data } }) => {
            if (data) {
                deliveryUpdatedHandler(deliveryId, data.deliveriesUpdated);
            }
        },
    });

    if (deliveryLoading && !deliveryData) {
        return (
            <Container>
                <Loader />
            </Container>
        );
    }

    if (deliveryError || !deliveryData) {
        throw new Error('Une erreur est survenue lors de la récupération de la livraison');
    }

    const { delivery } = deliveryData;

    if (!delivery) {
        return (
            <Container>
                <Header>
                    <HeaderTitle>
                        <PageTitle page={PAGES.deliveryDetails} />
                    </HeaderTitle>
                    <CTAsContainer>
                        <Link to={PAGES.deliveries.url}>
                            <TotemPrimaryButton $isSecondaryStyle>Retour</TotemPrimaryButton>
                        </Link>
                    </CTAsContainer>
                </Header>
                <div style={{ color: 'red', textAlign: 'center', marginTop: 50 }}>Livraison introuvable</div>
            </Container>
        );
    }

    return <DeliveryDetailsForm delivery={delivery} />;
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const CTAsContainer = styled.div`
    & > :not(:first-child) {
        margin-left: 5px;
    }
`;
